import MenuHamburgerIcon from './component'

export default MenuHamburgerIcon
